import { ApolloLink } from 'apollo-link';
const timeStartLink = new ApolloLink((operation, forward) => {
    operation.setContext({ start: Date.now() });
    return forward(operation);
});
const logTimeLink = new ApolloLink((operation, forward) => {
    return forward(operation).map(data => {
        // data from a previous link
        const time = Date.now() - operation.getContext().start;
        console.log(new Date(), `operation ${operation.operationName} took ${time} to complete`);
        return data;
    });
});
export const logOperationTime = timeStartLink.concat(logTimeLink);
//# sourceMappingURL=queryLoggingMiddleware.js.map